import { takeLatest, put, call } from 'redux-saga/effects';

import { saveFormData } from '../actions/saveFormData';
import { saveForm,saveFormFailure,saveFormSuccess } from '../slices/saveFormDataSlice';

function* handleSaveFormData(action:any):Generator<any, void, string> {
  try {
     // Call the saveFormData API function with the payload
    const projectDetails:any = yield call(saveFormData, action.payload); 
     // Dispatch the saveFormSuccess action with the response data
    yield put(saveFormSuccess(projectDetails));
  } catch (error:any) {
     // If there is an error, dispatch the saveFormFailure action with the error message
    yield put(saveFormFailure(error.message));
  }
}

// Watcher saga
function* saveFormDetails() {
  // Listen for the saveForm action and call the handleSaveFormData saga when dispatched
  yield takeLatest(saveForm.type, handleSaveFormData);
}
 
export default saveFormDetails;